import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=ec69c8e2"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports